import { BrandKey } from '../../../__generated__/queries-web';

export const AUTHORIZED_BRANDS_FOR_SET_TITLE = [BrandKey.CAM, BrandKey.FAC];
